"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _Section = _interopRequireDefault(require("../components/Section"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function BrandValues(_ref) {
  var vision = _ref.vision,
      mission = _ref.mission,
      overview = _ref.overview,
      brandValues = _ref.brandValues,
      gotoId = _ref.gotoId,
      setRef = _ref.setRef;
  var isEmptySection = !vision && !mission && (0, _lodash.default)(brandValues);
  return /*#__PURE__*/_react.default.createElement(_Section.default, {
    icon: "brand",
    gotoId: gotoId,
    setRef: setRef,
    title: "Our Brand",
    description: overview,
    emptyText: "There aren't any organisation statements added yet"
  }, isEmptySection ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, vision ? /*#__PURE__*/_react.default.createElement("div", {
    className: "section__break"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true,
    noMargin: "top"
  }, "Our Vision"), /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true,
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading2: true,
    className: "vision"
  }, "\"".concat(vision, "\"")))) : null, mission ? /*#__PURE__*/_react.default.createElement("div", {
    className: "section__break"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true,
    noMargin: "top"
  }, "Our Mission"), /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true,
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, mission))) : null, (0, _lodash.default)(brandValues) ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "section__break"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true,
    noMargin: "top"
  }, "Our Values"), /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true,
    className: "container"
  }, brandValues.map(function (_ref2, index) {
    var value = _ref2.value,
        description = _ref2.description;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      heading5: true,
      noMargin: "bottom"
    }, value), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      noMargin: "top"
    }, description), index !== brandValues.length - 1 ? /*#__PURE__*/_react.default.createElement("hr", null) : null);
  })))));
}

var _default = (0, _react.memo)(BrandValues);

exports.default = _default;